import { render, staticRenderFns } from "./RetrieveAs.vue?vue&type=template&id=23a3d592&scoped=true"
import script from "./RetrieveAs.vue?vue&type=script&lang=js"
export * from "./RetrieveAs.vue?vue&type=script&lang=js"
import style0 from "./RetrieveAs.vue?vue&type=style&index=0&id=23a3d592&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a3d592",
  null
  
)

export default component.exports